import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyD3vCmQhwuf7P6HCxgPmmTrw-XIWldx6us",
  authDomain: "icaplayer-440b4.firebaseapp.com",
  projectId: "icaplayer-440b4",
  storageBucket: "icaplayer-440b4.appspot.com",
  messagingSenderId: "607031809919",
  appId: "1:607031809919:web:84e7ad504ee75b40926c4a",
  measurementId: "G-FSV854CC9J",
};

export const firebaseExported = firebase.initializeApp(firebaseConfig);
export const db = firebaseExported.firestore();
